import invoiceExportReport from '../../assets/js/report/invoice_export/invoice'
export default {
  methods: {
    exportToMultiInvoices (ids, createRestOrder) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('post', `invoices/bulk_invoice_orders/${createRestOrder}`, { ids })
          .then(response => {
            const result = response.data
            let invoices = []
            result.invoices.map((x) => {
              let invoiceshtml = this.invoiceHeadContent()
              let lang = x.customer && x.customer.language ? this.$i18n.messages[x.customer.language].message : this.$i18n.messages[this.$i18n.locale].message
              const headers = [{ text: lang.invoiceReport.line, value: 'number' },
                { text: lang.invoiceReport.productDescription, value: 'description' },
                { text: lang.order.qty, value: 'qty' },
                { text: '', value: 'unitname' },
                { text: lang.orders.price, value: 'base_price' },
                { text: lang.product.discount, value: 'discount' },
                { text: lang.invoice.sum, value: 'sum_ex_vat' }]

              let translations = {
                telephone: lang.invoiceReport.telephone,
                email: lang.customer.email,
                web: lang.customer.web,
                business: lang.invoiceReport.businessEnterprises,
                orgNo: lang.invoiceReport.orgNo,
                accNo: lang.invoiceReport.accNo,
                orderNo: lang.invoiceReport.orderNo,
                invoiceAddress: lang.orders.invoiceAddress,
                deliveryAddress: lang.orders.deliveryAddress,
                ourRef: lang.invoiceReport.ourRef,
                yourRef: lang.invoiceReport.yourRef,
                saleRef: lang.invoiceReport.saleRef,
                betBet: lang.invoiceReport.betBet,
                levBet: lang.invoiceReport.levBet,
                deadline: lang.invoiceReport.deadline,
                customerNo: lang.invoiceReport.customerNo,
                orderDate: lang.whOrder.orderDate,
                invoiceDate: lang.invoiceReport.invoiceDate,
                dueDate: lang.invoice.duedate,
                delivery: lang.customer.delivery,
                installed: lang.customer.installed,
                customerInfo: lang.invoiceReport.customerInfo,
                tel: lang.invoiceReport.tel,
                mobile: lang.invoiceReport.mobile,
                totalExVat: lang.orders.totalExVat,
                vat: lang.customer.vatValue,
                roundOff: lang.invoiceReport.roundOff,
                totalIncVat: lang.invoiceReport.totalIncVat,
                kid: lang.invoiceReport.kid,
                amountPay: lang.invoiceReport.amountToPay,
                payDeadline: lang.invoiceReport.paymentDeadline,
                accNumber: lang.customer.accountnumber,
                stdSale: lang.orders.standardSales,
                deliveryTerms: lang.orders.deliveryTerms,
                invoice: lang.customer.invoice,
                creditNote: lang.invoice.creditNote,
                yourOrderNumber: lang.orders.yourOrderNumber,
                comments: lang.common.comments
              }
              invoiceshtml += invoiceExportReport(headers, x, translations, false)
              invoiceshtml += `</body></html>`
              invoiceshtml = btoa(unescape(encodeURIComponent(invoiceshtml)))
              invoices.push({ invoiceid: x.invoice.id, invoicehtml: invoiceshtml })
            })
            resolve(invoices)
          })
          .catch((err) => {
            this.invoiceGenerating = false
            reject(err)
          })
      })
    },
    invoiceHeadContent () {
      return `
      <html>
        <head>
          <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
          <style>
            .information-box {
              padding-left: 4px;
              padding-top: 1px;
              border: 1px solid;
              background: white;
            }
            .margin-adjustments {
              margin-top:2px !important;
              margin-bottom:2px !important;
            }
            .total-info {
              width: 40%;
              border: 3px solid;
              padding: 5px;
            }
            thead tr { page-break-inside:avoid; }
            tbody tr { page-break-inside:avoid; }
            .address-box { min-height: 100px; }
            .info-box-height { min-height: 80px; }
            .info-boxes>div, .noso_info { padding-left: 5px !important;padding-right: 5px !important;}
            .border { border: 1px solid #dddddd; }
            .noso_info div { padding-right: 0px !important; }
            .mt-4 { margin-top: 4%; }
            thead { display: table-header-group; }
            tfoot { display: table-row-group; }
            .container-fluid { page-break-before: always; }
            .table-invoice-items table tr, .table-invoice-items table tr td { page-break-inside: avoid; }
            .table-invoice-items tr td, .table-invoice-items tr th { font-size: 14px; }
            thead tr td, thead tr th { text-align: justify;word-break: break-word;padding: 2px !important;}
            .table-invoice-items tbody tr td, .table-invoice-items thead tr td, .table-invoice-items tbody tr th, .table-invoice-items thead tr th { border: none; }
          </style>
        </head>
        <body>`
    }
  }
}
